import http from '@/services/BackendService'

// ชั้นเดียวที่รู้ URL + response key ของฟีเจอร์ form (build บน BackendService)
export default {
    // รายการฟอร์ม published (option ค้นหา title)
    async fetchForms(q) {
        const { data } = await http.get('form', { params: { q: q || undefined } })
        return data.data
    },

    // ขอดาวน์โหลด — backend log + count++ แล้ว stream ไฟล์ PDF กลับ (blob)
    async requestDownload(id) {
        const { data } = await http.get(`form/${id}/download`, { responseType: 'blob' })
        return data   // Blob
    },
}
